import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

//const
import { QUERY_KEYS } from 'consts/queryKeys';
//custom hooks
import { useCustomToast } from 'hooks';
//services
import { calculateFromPriceList } from 'modules/accommodations/features/reservations/api';

export const useCalculationAutoCalculateMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const { mutate, isLoading } = useMutation(calculateFromPriceList, {
    onSuccess: response => {
      if (response?.reservationErrorsAndInfo?.errors) {
        errorToast(response.reservationErrorsAndInfo.errors[0].message);

        return;
      }
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_SERVICES, {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATIONS_PAYMENTS, {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_TYPE, {
        refetchInactive: true,
      });
      successToast(t('Calculation saved successfully.'));
    },
    onError: () => errorToast(),
  });

  return {
    mutate,
    isLoading,
  };
};
